import VendorsCookieConsent from './cookie-consent';
import VendorsFancybox      from './fancybox';
import VendorsDatepicker    from './datepicker';
import VendorsModal      from './bootstrap/modal';

const index = () => {
	const pageType = document.body.dataset.pageType;
	/* eslint-disable no-console */
	// if (processEnv === 'development') {
	// 	console.log('Vendors');
	// }
	/* eslint-enable no-console */

	if (pageType !== 'modal') {
		VendorsCookieConsent();
		VendorsModal();
	}

	VendorsDatepicker();
	VendorsFancybox().then(result => {
		// Do nothing...
	});
};

export default index;
